import { render } from "./ListItemPublicacao.vue?vue&type=template&id=6ebddbb8&scoped=true"
import script from "./ListItemPublicacao.vue?vue&type=script&lang=js"
export * from "./ListItemPublicacao.vue?vue&type=script&lang=js"

import "./ListItemPublicacao.vue?vue&type=style&index=0&id=6ebddbb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebddbb8"]])

export default __exports__